<!--
 * @Author: your name
 * @Date: 2021-08-27 16:41:58
 * @LastEditTime: 2021-12-08 16:17:25
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \鲁南\src\modules\workshopEmergencyHandle\components\integratedGroup\addIntegratedTree.vue
-->
<template>
  <el-dialog
    :visible.sync="showDialog"
    v-dialogDrag
    width="600px"
    :title="`${type === 1 ? '新增' : '修改'}综合应急组`"
  >
    <el-form label-width="120px" :model="form" :rules="rules" ref="form">
      <el-form-item label="综合应急组名称" prop="integratedGroupName">
        <el-input
          type="text"
          maxlength="30"
          placeholder="请输入名称"
          v-model="form.integratedGroupName"
        ></el-input>
      </el-form-item>
      <el-form-item label="综合应急组职责" prop="dutyDesc">
        <el-input
          type="textarea"
          placeholder="请输入职责"
          v-model="form.dutyDesc"
          maxlength="200"
                show-word-limit
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button type="info" @click="cancel">取消</el-button>
      <el-button type="primary" @click="save">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import api from "../../api";
export default {
  data() {
    return {
      showDialog: false,
      form: {
        integratedGroupName: "",
        dutyDesc: "",
      },
      rules: {
        integratedGroupName: [
          {
            required: true,
            message: "请输入应急组名称",
            trigger: "blur",
          },
        ],
        dutyDesc: [
          {
            required: true,
            message: "请输入职责",
            trigger: "blur",
          },
        ],
      },
      type: 1,
    };
  },
  created() {},
  methods: {
    show(groupInfo, type) {
      this.type = type;
      this.showDialog = true;
      this.$nextTick(() => {
        if (type == 1) {
          let { parentCode } = groupInfo;
          this.parentCode = parentCode;
        } else {
          let { parentCode, ...form } = groupInfo;
          this.form = form;
          this.parentCode = parentCode;
          this.integratedGroupCode = groupInfo.integratedGroupCode;
        }
      });
    },
    async save() {
      try {
        const valid = await this.$refs.form.validate();
        if (!valid) return;
        const params =
          this.type === 1
            ? {
                parentCode: this.parentCode,
                ...this.form,
              }
            : { integratedGroupCode: this.integratedGroupCode, ...this.form };
        const realApi =
          this.type === 1 ? api.addIntegratedGroup : api.updateIntegratedGroup;
        const { success, msgContent } = await this.$fetch(realApi, params);
        if (success) {
          this.cancel();
          this.$emit("refresh-tree");
        } else {
          this.$message.warning(msgContent);
        }
      } catch (error) {
        console.error(error);
      }
    },
    cancel() {
      console.log(1);
      this.$refs.form.resetFields();
      this.showDialog = false;
    },
  },
};
</script>

<style></style>
